import React, { Component } from 'react';

import './dropdown.css';

export default class DropDownExt extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
    };
    this.setState = this.setState.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    if (this.state.isOpen) {
      document.removeEventListener('click', this.onClick);
    } else {
      document.addEventListener('click', this.onClick);
    }
    this.setState({ isOpen: !this.state.isOpen });
  }

  render() {
    return (
      <div className={`dropdown ${this.props.className || ''}`}>
        <button
          data-draggable
          className={this.props.triggerClassName}
          onClick={this.onClick}
        >
          {this.props.children}
        </button>
        {this.state.isOpen ? (
          <div className="actions-menu">
            {this.props.items.map((item, i) => (
              <div key={i}>
                {item.separator ? (
                  <div className="action-menu-separator" />
                ) : (
                  <div
                    className={`action-menu-button ${
                      item.selected ? 'actions-menu-selected' : ''
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      item.onClick();
                    }}
                  >
                    {item.icon}
                    <div className="action-button-content">
                      <span dangerouslySetInnerHTML={{ __html: item.title }} />
                      {item.description ? (
                        <div className="action-button-description">
                          {item.description}
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}
